import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
    { label: "Nosotros", href: "/nosotros" },
    { label: "Servicios", href: "/#servicios" },
    { label: "Contacto", href: "/#contacto" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-40 ${scrolled ? "glass-header" : "bg-transparent"} transition-all duration-300`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <a href="/" className="flex items-center" data-testid="logo-link">
                    <img
                        src="/ramsol-logo.jpg"
                        alt="RAMSOL · Soluciones Constructivas"
                        className="h-12 md:h-14 w-auto block rounded-full"
                    />
                </a>

                <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
                    {NAV.map((n) => (
                        <a
                            key={n.href}
                            href={n.href}
                            data-testid={`nav-link-${n.label.toLowerCase()}`}
                            className="text-xs font-bold uppercase tracking-[0.2em] text-white/80 hover:text-[#14888F] transition-colors"
                        >
                            {n.label}
                        </a>
                    ))}
                    <a href="/#contacto" className="btn-primary !py-2.5 !px-5 !text-[0.7rem]" data-testid="nav-cta-button">
                        Cotizar Obra
                    </a>
                </nav>

                <button
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden p-2 text-white"
                    aria-label="Abrir menú"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-[#0A0A0A]" data-testid="mobile-nav">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {NAV.map((n) => (
                            <a
                                key={n.href}
                                href={n.href}
                                onClick={() => setOpen(false)}
                                className="text-sm font-bold uppercase tracking-[0.2em] text-white/85"
                                data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
                            >
                                {n.label}
                            </a>
                        ))}
                        <a href="/#contacto" onClick={() => setOpen(false)} className="btn-primary justify-center" data-testid="mobile-nav-cta">
                            Cotizar Obra
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
